import { STORAGE_TYPES } from '../../hazwaste-shared/storage-types.ts';
const vesselIDs = new Set<string>(STORAGE_TYPES.map((type) => type.id));
/** Storage choices offered directly by Tier II, outside the physical-vessel catalog. */
export const ADDITIONAL_INVENTORY_STORAGE_CODES = new Set(['B', 'C', 'G', 'I', 'M', 'N']);
export function hasSelectedVesselType(line: {
  vesselType: string | null;
  vesselTypeName: string | null;
  storageType: string | null;
}): boolean {
  if (line.vesselType === 'other') return !!line.vesselTypeName?.trim();
  return vesselIDs.has(line.vesselType ?? '') || ADDITIONAL_INVENTORY_STORAGE_CODES.has(line.storageType ?? '');
}
